import * as React from 'react';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import Pagination from '@mui/material/Pagination';
import { NavLink } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import UpdateIcon from '@mui/icons-material/Update';
import Tooltip from '@mui/material/Tooltip';
import { useForm } from 'react-hook-form';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import FormControl from '@mui/material/FormControl';
import { useParams , useNavigate } from 'react-router-dom';
import { useState, useEffect , useContext} from 'react';
import { AuthContext } from '../../../authContext/context';
import { postRequest } from '../../../lib/api';
import toast from 'react-hot-toast';
import BreadcrumbsWrapper from '../../../components/breadcrumbs' 
import ApoitmentList from '../Appointments/ApoitmentList'
import NotesList from '../Notes/notes'
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import Swal from 'sweetalert2';
import { checkPermission } from '../../../utils/checkPermissions';
import { Typography } from '@mui/material';


export default function ViewCustomers() {
   const {id} = useParams()
   const navigate = useNavigate()
   const authCtx = useContext(AuthContext)
   const userPermissions = authCtx.permissions; // Changed from authCtx.user?.permissions
   const isSuperAdmin = authCtx.isSuperAdmin;
   
   const [customerData, setCustomerData] = useState(null);
   const [loading, setLoading] = useState(true);
   const [activeTab, setActiveTab] = useState('overview');
   const [productList, setProductList] = useState([]);
   const [leadsList, setLeadsList] = useState([]);
   
   const {
     register,
     handleSubmit,
     reset,
     formState: { errors },
   } = useForm();
   
   // Check view permission - also allow if user has lead permissions
   const hasCreateLeads = checkPermission(userPermissions, 'leads', 'create');
   const hasViewLeads = checkPermission(userPermissions, 'leads', 'view');
   const canViewDetails = isSuperAdmin || checkPermission(userPermissions, 'customers', 'view_details') || hasCreateLeads || hasViewLeads;
   const canEdit = isSuperAdmin || checkPermission(userPermissions, 'customers', 'edit');
   const canDelete = isSuperAdmin || checkPermission(userPermissions, 'customers', 'delete');
   
   // Check notes permissions
   const canCreateNotes = isSuperAdmin || (userPermissions && checkPermission(userPermissions, 'notes', 'create'));
   const canViewNotes = isSuperAdmin || (userPermissions && checkPermission(userPermissions, 'notes', 'view'));
   const canEditNotes = isSuperAdmin || (userPermissions && checkPermission(userPermissions, 'notes', 'edit'));
   
   // Show Notes tab if user has ANY notes permission
   const hasAnyNotesPermission = canViewNotes || canCreateNotes || canEditNotes;
   
   console.log('Notes permissions check:', {
     userPermissions,
     notesPermissions: userPermissions?.notes,
     canViewNotes,
     isSuperAdmin
   });

  const fetchCustomerDetails = async () => {
    setLoading(true);
    try {
      const response = await postRequest(`private/viewCustomer/${id}`, {});
      console.log(response , 'jdjs')
      if (response?.data) {
        setCustomerData(response.data);
      } else {
        setCustomerData(null);
      }
    } catch (error) {
      console.error("Error fetching customer:", error);
      setCustomerData(null);
    } finally {
      setLoading(false);
    }
  };

const handleNoteSubmit = async (data) => {
  const payload = {
    //customer_id: id,
    name: data?.name,
    created_id: localStorage.getItem('id') || null,
  };

  try {
    const response = await postRequest('private/createNotes', payload);
    if (response?.status === 200) {
    //  toast.success('Note added successfully');
      reset(); // clear the form
      fetchCustomerDetails(); // optionally refresh customer data
    } else {
      //toast.error(response?.message || 'Failed to add note');
    }
  } catch (err) {
    //toast.error(err?.message || 'Something went wrong');
  }
};

const handleSendEmailConfirmation = async () => {
  // Confirm before sending
  const result = await Swal.fire({
    title: 'Send Email Confirmation?',
    text: `Send confirmation email to ${customerData?.email || 'this customer'}?`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#6f42c1',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'Yes, send it!',
    cancelButtonText: 'Cancel'
  });

  if (result.isConfirmed) {
    try {
      const response = await postRequest(`private/sendCustomerEmailConfirmation/${id}`, {});

      if (response?.status === 200 || response?.status === 'success') {
        Swal.fire({
          icon: 'success',
          title: 'Email Sent!',
          text: 'Confirmation email has been sent successfully.',
          timer: 2000,
          showConfirmButton: false
        });
      } else {
        throw new Error(response?.message || 'Failed to send email');
      }
    } catch (err) {
      console.error('Error sending email confirmation:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: err?.message || 'Failed to send confirmation email. Please try again.'
      });
    }
  }
};

const fetchProductList = async () => {
  try {
    const response = await postRequest('private/getproductList', {});
    if (response?.status === 200 && Array.isArray(response?.data)) {
      setProductList(response.data);
    } else {
      setProductList([]);
    }
  } catch (error) {
    console.error("Error fetching products:", error);
    setProductList([]);
  }
};

const fetchCustomerLeads = async () => {
  try {
    console.log('🔍 Fetching all leads for customer _id:', customerData?._id);

    const response = await postRequest('private/getLeadsByCustomerId', {
      customer_id: customerData?._id
    });

    console.log('📊 Customer leads response:', response);

    if (response?.status === 200 && Array.isArray(response?.data)) {
      console.log('✅ Found', response.data.length, 'leads for customer');
      // Hide probate marketing quotes while retaining regular estate leads.
      setLeadsList(
        response.data.filter((lead) => lead.marketing_type !== 'Probate')
      );
    } else {
      console.log('❌ No leads found or invalid response');
      setLeadsList([]);
    }
  } catch (error) {
    console.error("❌ Error fetching customer leads:", error);
    setLeadsList([]);
  }
};

useEffect(() => {
  fetchProductList();
}, []);

useEffect(() => {
  if (canViewDetails) {
    fetchCustomerDetails();
  }
}, [id, canViewDetails]);

useEffect(() => {
  if (customerData && authCtx.token) {
    fetchCustomerLeads();
  }
}, [customerData, authCtx.token]);

  if (!canViewDetails) {
    return (
      <>
        <BreadcrumbsWrapper
          items={[
            { label: 'Dashboard', path: '/dashboard' },
            { label: 'Customers', path: '/customers' },
            { label: 'View Customer', path: '' },
          ]}
        />
        <br></br>
        <div className='page-header pb-3'>
          <h1 className='mt-0 mb-0'>View Customer</h1>
        </div>
        <div className='page-top-formview mb-3 text-center'>
          <Typography variant="h6" color="text.secondary">
            You do not have permission to view customer details.
          </Typography>
        </div>
      </>
    );
  }






  return (
    <>
         <BreadcrumbsWrapper
        items={[
          { label: 'Dashboard', path: '/dashboard' },
          { label: 'Customers', path: '/customers' },
          { label: 'View Customer', path: null }
        ]}
      />
      <br></br>
      <div className='page-header'>
       <h1 className='mt-0'>
  {loading ? 'Loading...' : `${customerData?.forename|| '-'} ${customerData?.surname || '-'}  #${customerData?.customer_id || '-'}`}
</h1>

        <div className='header-right-btn'>
        <Stack spacing={2} direction="row">
  {activeTab === 'appointment' ? (
    <Button variant="outlined" className='red-outline-btn text-capitalize'>
      <NavLink to={`/customers/create/appoitment/${id}`} className="red-link-text">
        <PersonAddOutlinedIcon /> &nbsp; Create Appointment
      </NavLink>
    </Button>
  ) : activeTab === 'notes' ? (
    canCreateNotes && (
      <Button variant="outlined" className='red-outline-btn text-capitalize'>
        <NavLink to={`/customer/create/note/${id}`} className="red-link-text">
          <PersonAddOutlinedIcon /> &nbsp; Add Note
        </NavLink>
      </Button>
    )
  ) :('')}
  
   {/* (
    <Button variant="outlined" className='red-outline-btn text-capitalize'>
      <NavLink to={`/customer/edit/${id}`} className="red-link-text">
        <PersonAddOutlinedIcon /> &nbsp; Edit Customer
      </NavLink>
    </Button>
  )} */}
</Stack>

        </div>
      </div>

      {/* Search Form */}
      <div className='page-top-formview mb-3'>
       
          <div className='customer-tab-view'> 
<Tabs
  activeKey={activeTab}
  onSelect={(k) => setActiveTab(k)}
  className=""
>

                    <Tab eventKey="overview" title="Overview">

<div>
         <Table striped responsive bordered>
  <tbody>
    <tr>
      <td>
        <MailOutlineIcon /> &nbsp; {customerData?.email || 'N/A'} &nbsp;
        {customerData?.emailVerified ? (
          <span style={{
            backgroundColor: '#4caf50',
            color: 'white',
            padding: '2px 8px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: 'bold',
            marginRight: '8px'
          }}>
            ✓ VERIFIED
          </span>
        ) : (
          <span style={{
            backgroundColor: '#ff9800',
            color: 'white',
            padding: '2px 8px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: 'bold',
            marginRight: '8px'
          }}>
            ⚠ NOT VERIFIED
          </span>
        )}
        <NavLink className="red-link-text w-18" to={`/customers/setEmail/${id}`}>
          <EditOutlinedIcon /> Edit
        </NavLink>
        &nbsp; | &nbsp;
        <span
          className="red-link-text w-18"
          style={{ cursor: 'pointer' }}
          onClick={handleSendEmailConfirmation}
        >
          {customerData?.emailVerified ? 'Resend Confirmation' : 'Send Confirmation'}
        </span>
      </td>
      <td>
        <PhoneIcon /> &nbsp; {customerData?.phone_number || 'N/A'} &nbsp;
        <NavLink className="red-link-text" to={`/customers/setPhone/${id}`}>Edit</NavLink>
        &nbsp;
        {/* <NavLink className="red-link-text w-18">
          <DeleteOutlineOutlinedIcon /> Delete
        </NavLink> */}
      </td>
    </tr>
  </tbody>
</Table>

</div>


                        <Table striped responsive bordered >
        <thead>
            <tr>
            <th colSpan={6} className='bg-grey'> Leads</th>
          </tr>
          <tr>
            <th>Ref</th>
            <th>Product</th>
            <th>Status</th>
            <th>Created</th>
            <th>Instructed</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {leadsList.length > 0 ? (
            leadsList.map((lead, index) => {
              const createdDate = lead.createdAt ? new Date(lead.createdAt).toLocaleDateString() : '-';
              const instructedDate = lead.customer_confirmed_at
                ? new Date(lead.customer_confirmed_at).toLocaleString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                  })
                : '-';

              // Get product title for routing
              const productTitleLower = (lead.product_id?.title || lead.product_type || '').toLowerCase();
              const leadId = lead.lead_id || lead._id;
              const serviceType = (lead.service_type || '').toLowerCase();

              console.log('🔍 Lead routing debug:', {
                leadId,
                productTitle: lead.product_id?.title,
                productTitleLower,
                serviceType: lead.service_type,
                lead
              });

              // Determine view path based on product type (same logic as leads listing)
              let viewPath;

              // Check for Will products FIRST (before other checks)
              if (serviceType === 'single' || serviceType === 'mirror' || serviceType === 'codicil' ||
                  productTitleLower === 'will' || productTitleLower.includes('will (single)') ||
                  productTitleLower.includes('will (mirror)') || productTitleLower.includes('will (codicil)')) {
                viewPath = `/leads/view/will/${leadId}`;
              } else if (productTitleLower.includes('lss will')) {
                viewPath = `/leads/view/lss-will/${leadId}`;
              } else if (lead.service_type === 'Review_Legal_Pack' || productTitleLower.includes('review of legal pack')) {
                viewPath = `/leads/view/review-of-legal-pack/${leadId}`;
              } else if (lead.service_type === 'First_Registration' || productTitleLower.includes('first registration')) {
                viewPath = `/leads/view/first-registration/${leadId}`;
              } else if (lead.service_type === 'Mortgage_Redemption' || productTitleLower.includes('mortgage redemption')) {
                viewPath = `/leads/view/mortgage-redemption/${leadId}`;
              } else if (lead.service_type === 'Remortgage' || productTitleLower.includes('remortgage')) {
                viewPath = `/leads/view/remortgage/${leadId}`;
              } else if (lead.service_type === 'Transfer_of_Equity' || productTitleLower.includes('transfer of equity')) {
                viewPath = `/leads/view/transfer-of-equity/${leadId}`;
              } else if (lead.service_type === 'Purchase_Sale' || (productTitleLower.includes('purchase') && productTitleLower.includes('sale'))) {
                viewPath = `/leads/view/sale-purchase/${leadId}`;
              } else if (lead.service_type === 'Sale' || productTitleLower.includes('sale')) {
                viewPath = `/leads/view/sale/${leadId}`;
              } else if (lead.service_type === 'Purchase' || productTitleLower.includes('purchase')) {
                viewPath = `/leads/view/conveyancing/${leadId}`;
              } else if (lead.is_conveyancing || productTitleLower.includes('conveyancing') || productTitleLower.includes('conveycing')) {
                viewPath = `/leads/view/conveyancing/${leadId}`;
              } else {
                // Default: slugify the product title
                const productSlug = productTitleLower.replace(/\s+/g, '-') || 'conveyancing';
                viewPath = `/leads/view/${productSlug}/${leadId}`;
              }

              // Format product display with Will type if applicable
              let productDisplay = lead.product_id?.title || lead.product_type || lead.service_type || '-';

              // If service_type is single/mirror/codicil, it's a Will product
              if (serviceType === 'single' || serviceType === 'mirror' || serviceType === 'codicil') {
                // Capitalize first letter of service type
                const formattedServiceType = serviceType.charAt(0).toUpperCase() + serviceType.slice(1);
                productDisplay = `${lead.product_id?.title || 'Will'} (${formattedServiceType})`;
              }
              // Also check if product title contains 'will' and has service_type
              else if (productTitleLower.includes('will') && lead.service_type) {
                const formattedServiceType = lead.service_type.charAt(0).toUpperCase() + lead.service_type.slice(1);
                productDisplay = `${lead.product_id?.title || 'Will'} (${formattedServiceType})`;
              }

              return (
                <tr key={lead._id || index}>
                  <td>{index + 1}</td>
                  <td>{productDisplay}</td>
                  <td>{lead.status || 'Otto'}</td>
                  <td>{createdDate}</td>
                  <td>{instructedDate}</td>
                  <td>
                    <NavLink to={viewPath} className="red-link-text">View</NavLink>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="6" className="text-center">No leads found for this customer</td>
            </tr>
          )}
        </tbody>
                        </Table>
                  
                 <div style={{display: "flex", alignItems: "center", justifyContent:"space-between"}}>
            {checkPermission(userPermissions, 'leads', 'create') && (
              <Dropdown className='mb-0 ps-0'>
                <Dropdown.Toggle className='dropdown-border-btn red-outline-btn text-capitalize' id="dropdown-basic">
                  <AddIcon /> Add New Lead
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {productList.length > 0 ? (
                    productList.map((item) => {
                      const slug = item.title.toLowerCase().replace(/\s+/g, '-');
                      return (
                        <Dropdown.Item
                          key={item._id}
                          as={Link}
                          to={`/${slug}/create?customerId=${id}`}
                          state={{ productId: item._id }}
                        >
                          {item.title}
                        </Dropdown.Item>
                      );
                    })
                  ) : (
                    <Dropdown.Item disabled>No products available</Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            )}

                <Dropdown className='mb-0 ps-0 '>
                <Dropdown.Toggle className='dropdown-border-btn red-outline-btn text-capitalize' id="dropdown-basic">
                  <AddIcon /> More Action
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={async () => {
                      const result = await Swal.fire({
                        title: 'Are you sure?',
                        text: 'Do you really want to delete this customer?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#d33',
                        cancelButtonColor: '#3085d6',
                        confirmButtonText: 'Yes, delete it!',
                      });

                      if (result.isConfirmed) {
                        try {
                          const response = await postRequest(`private/deleteCustomer/${id}`, {});
                          if (response?.status === 200) {
                            Swal.fire('Deleted!', 'Customer has been deleted.', 'success');
                            setTimeout(() => {
                              navigate('/customers')
                            }, 1000);
                          } else {
                            Swal.fire('Error', response?.message || 'Failed to delete customer.', 'error');
                          }
                        } catch (err) {
                          Swal.fire('Error', err?.message || 'Something went wrong.', 'error');
                        }
                      }
                    }}
                  >
                    Delete Customer
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>


    </div> 
                    </Tab>

                    {hasAnyNotesPermission && (
                    <Tab eventKey="notes" title="Notes">
                      <NotesList 
                        canViewNotes={canViewNotes}
                        canCreateNotes={canCreateNotes}
                        canEditNotes={canEditNotes}
                      />
                    </Tab>
                    )}

                     <Tab eventKey="appointment" title="Appointment">
                      
                     <ApoitmentList/>
                    </Tab>

                </Tabs>
          </div>


      </div>

      {/* Table View */}
      <div>
        

     
      </div>
    </>
  );
}
